import React from 'react';
import { formatLevelBadge } from '../../utils/levels';
import styles from './LevelBadge.module.css';

interface LevelBadgeProps {
  level: number;
  size?: 'small' | 'medium' | 'large';
  showTitle?: boolean;
  className?: string;
}

export const LevelBadge: React.FC<LevelBadgeProps> = ({ 
  level, 
  size = 'medium', 
  showTitle = true,
  className = ''
}) => {
  const title = formatLevelBadge(level);
  const badgeClass = `${styles.badge} ${styles[`level${level}`]} ${styles[size]} ${className}`;

  return (
    <div className={badgeClass} title={showTitle ? `${title} (Level ${level})` : undefined}>
      <div className={styles.badgeInner}>
        <span className={styles.levelNumber}>{level}</span>
        {size !== 'small' && <span className={styles.levelTitle}>{title}</span>}
      </div>
    </div>
  );
};

export default LevelBadge;
